// src/theme.js
import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

// Kiosk-specific theme that builds on top of darkTheme
export const kioskTheme = createTheme(darkTheme, {
  palette: {
    background: {
      default: '#010101',
      paper: '#17131F',
    },
    primary: {
      main: '#FFC727',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#C7C2D2',
    },
  },
  shape: {
    borderRadius: 18,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 999,
          fontWeight: 600,
        },
      },
    },
  },
});
